import axios from "axios";
import React, { useState } from "react";
import {
  Button,
  Col,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
} from "reactstrap";
import { ConvertDate } from "../Function/ConvertDate";
import { GetCookieToken } from "../Cookie/GetCookie";
import { forEach } from "lodash";

const ModalNotApprove = ({
  leaveDataEdit,
  modalNotApprove,
  handleCloseModalNoApprove,
  setModalNotApprove,
  sendApproveDataStatus,
  handleOpenSubmitSuccess,
  getApproveDataTable,
  loadingApproveTable,
}) => {
  const baseURL = process.env.REACT_APP_API_CORS;
  const token = GetCookieToken("userToken");

  const [buttonValidate, setbuttonValidate] = useState(true);

  const editLeaveDaysAndChangeDaysInLeaveData = async (id) => {
    try {
      const res = await axios.put(
        baseURL + `/api/leave/${id}`,
        {
          leave_type_id: leaveDataEdit?.leave_type_id, //ประเภทใบลา
          form_type: leaveDataEdit?.form_type, //ประเภทฟอร์มการลา
          form_name: leaveDataEdit?.form_name, //ชื่อฟอร์มการลา
          budget_year: leaveDataEdit?.budget_year, //ปีงบประมาณ
          leave_name:
            leaveDataEdit?.leave_name.split(" ")[0] + " (ไม่อนุมัติยกเลิก)", //ชื่อเรื่องการลา
          send_to: leaveDataEdit?.send_to, //เรียน
          leave_from_date: ConvertDate(
            leaveDataEdit?.leave_from_date
          )?.toDateISO(), //ตั้งแต่วันที่
          leave_from_timetype: leaveDataEdit?.leave_from_timetype, //ช่วงเวลา
          leave_to_date: ConvertDate(leaveDataEdit?.leave_to_date)?.toDateISO(), //ถึงวันที่
          leave_to_timetype: leaveDataEdit?.leave_to_timetype, //ช่วงเวลา
          leave_days: leaveDataEdit?.leave_days, //กำหนดหรือจำนวนวัน
          change_days: leaveDataEdit?.leave_days,
          note: leaveDataEdit?.note || "", //หมายเหตุ
          user_id: leaveDataEdit?.user_id, //ไอดีผู้ส่งฟอร์ม
          // leave_status: leaveDataEdit?.leave_status,
          approve_user_id: leaveDataEdit?.approve_user_id,
          approve_user: leaveDataEdit?.approve_user,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } catch (err) {
      console.error(err);
    }
  };

  const deleteDateCancelWaitingRequest = async (id, filterStatus = 2) => {//ถ้า allow cancel ลบ 1 และเปลี่ยน 2 เป็น 1
    let daytoDelete;                                                      //ถ้าไม่ ลบ 2
    const getDayBeforeDelete = async (id) => {
      try {
        const url = baseURL + "/api/leave/cancel/list/datatable";
        const params = new URLSearchParams({
          page: 1,
          size: 10000,
          "order[0]": "date_cancel",
          "order[1]": "ASC",
          "filter[leave_data_id][0]": id,
          "filter[cancel_date_status][0]": filterStatus,
        });
        const config = {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params,
        };
        const res = await axios.get(url, config);
        let result = res?.data?.result;
        let idArray = [];
        result.forEach(element => {
          idArray.push(element?.id_leave_date_list)
        });
        return idArray;
      } catch (err) {
        console.error(err);
      }
    };
    
    const deleteDateRequest = async (arrDateCancel) => {
      try {
        (await arrDateCancel) &&
          await arrDateCancel.forEach(async element => {
          const res = await axios.delete(
            baseURL + `/api/leave/cancel/list/${element}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
        });
      } catch (err) {
        console.error(err);
      }
    };
    daytoDelete = await getDayBeforeDelete(id);
    
    await deleteDateRequest(daytoDelete);
  };

  return (
    <Modal
      centered
      isOpen={modalNotApprove?.modal}
      toggle={() => {
        handleCloseModalNoApprove();
        setbuttonValidate(true);
      }}
    >
      <ModalHeader
        toggle={() => {
          handleCloseModalNoApprove();
          setbuttonValidate(true);
        }}
      >
        ดำเนินการ{modalNotApprove?.name}
      </ModalHeader>
      <ModalBody>
        <FormGroup row>
          <Label xxl={2} className="text-end">
            เหตุผล :
          </Label>
          <Col xxl={10}>
            <Input
              type="text"
              placeholder="กรุณาระบุเหตุผล"
              onChange={(e) => {
                setModalNotApprove((prev) => ({
                  ...prev,
                  reason: e.target.value,
                }));
                if (e.target.value.trim() !== "") {
                  setbuttonValidate(false);
                } else {
                  setbuttonValidate(true);
                }
              }}
              invalid={buttonValidate}
            />
          </Col>
        </FormGroup>
        <FormGroup row className="mt-2 d-flex justify-content-end">
          <Col xxl={3}>
            <Button
              color="success"
              className="w-100"
              onClick={async () => {
                if (!buttonValidate) {
                  if (modalNotApprove?.name === "ไม่อนุญาต") {
                    // await sendLeaveDataStatus(
                    //   modalNotApprove?.itemUpdate,
                    //   modalNotApprove?.leaveDataStatus,
                    //   modalNotApprove?.leaveApproveStatus
                    // );
                    await sendApproveDataStatus(
                      modalNotApprove?.leaveApproveId,
                      modalNotApprove?.leaveDataId,
                      modalNotApprove?.leaveApproveStatus,
                      modalNotApprove?.reason
                    );
                    await handleCloseModalNoApprove();
                    await loadingApproveTable();
                    await getApproveDataTable(1);
                    await handleOpenSubmitSuccess();
                  } else if (modalNotApprove?.name === "ไม่อนุมัติ") {
                    // await sendLeaveDataStatus(
                    //   modalNotApprove?.itemUpdate,
                    //   modalNotApprove?.leaveDataStatus,
                    //   modalNotApprove?.leaveApproveStatus
                    // );
                    await sendApproveDataStatus(
                      modalNotApprove?.leaveApproveId,
                      modalNotApprove?.leaveDataId,
                      modalNotApprove?.leaveApproveStatus,
                      modalNotApprove?.reason
                    );
                    await handleCloseModalNoApprove();
                    await loadingApproveTable();
                    await getApproveDataTable(1);
                    await handleOpenSubmitSuccess();
                  } else if (
                    modalNotApprove?.name === "ไม่อนุญาตยกเลิก" ||
                    modalNotApprove?.name === "ไม่อนุมัติยกเลิก"
                  ) {
                    if (leaveDataEdit) {
                      // await deleteDateCancelWaitingRequest(
                      //   leaveDataEdit?.leave_data_id
                      // );//4545
                      await editLeaveDaysAndChangeDaysInLeaveData(leaveDataEdit?.leave_data_id);
                    }
                    // await sendLeaveDataStatus(
                    //   modalNotApprove?.itemUpdate,
                    //   modalNotApprove?.leaveDataStatus,
                    //   modalNotApprove?.leaveApproveStatus
                    // );
                    //4545
                    await sendApproveDataStatus(
                      modalNotApprove?.leaveApproveId,
                      modalNotApprove?.leaveDataId,
                      modalNotApprove?.leaveApproveStatus,
                      modalNotApprove?.reason
                    );
                    await handleCloseModalNoApprove();
                    await loadingApproveTable();
                    await getApproveDataTable(1);
                    await handleOpenSubmitSuccess();
                  } else if (modalNotApprove?.name === "ส่งกลับแก้ไข") {
                    // await sendLeaveDataStatus(
                    //   modalNotApprove?.itemUpdate,
                    //   modalNotApprove?.leaveDataStatus,
                    //   modalNotApprove?.leaveApproveStatus
                    // );
                    await sendApproveDataStatus(
                      modalNotApprove?.leaveApproveId,
                      modalNotApprove?.leaveDataId,
                      modalNotApprove?.leaveApproveStatus,
                      modalNotApprove?.reason
                    );
                    await handleCloseModalNoApprove();
                    await loadingApproveTable();
                    await getApproveDataTable(1);
                    await handleOpenSubmitSuccess();
                  }
                }
              }}
            >
              บันทึก
            </Button>
          </Col>
          <Col xxl={3}>
            <Button
              className="w-100"
              color="danger"
              onClick={() => {
                handleCloseModalNoApprove();
              }}
            >
              ยกเลิก
            </Button>
          </Col>
        </FormGroup>
      </ModalBody>
    </Modal>
  );
};

export default ModalNotApprove;
